import { Box, Chip } from '@mui/material';
import { PROGRESS_STATUS, StatusTypes } from '../../consts/enums';
import { LockClosed } from '../../icons/lock-closed';
import style from './style';

type Props = {
  label: string,
  type: StatusTypes | keyof typeof PROGRESS_STATUS,
  isLockedIcon?: boolean,
}

const lockedIcon = (type: StatusTypes | keyof typeof PROGRESS_STATUS) => {
  return (
    <Box sx={ {
      lineHeight: 1.1,
      svg: {
        color: style.colors[type].color,
      },
    } }
    >
      <LockClosed fontSize="small" />
    </Box>
  );
};

const Status = ({
  label,
  type,
  isLockedIcon,
}: Props): JSX.Element => {
  return (
    <Chip
      icon={ isLockedIcon ? lockedIcon(type) : undefined }
      variant="outlined"
      label={ label }
      sx={ {
        border: 0,
        ...style.colors[type],
        lineHeight: 1.5,
      } }
    />
  );
};
Status.defaultProps = {
  isLockedIcon: false,
};

export default Status;
